var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagingPlusSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#62BA46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 18C26 16.8954 26.8954 16 28 16C29.1046 16 30 16.8954 30 18V38C30 39.1046 29.1046 40 28 40C26.8954 40 26 39.1046 26 38V18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26C39.1046 26 40 26.8954 40 28C40 29.1046 39.1046 30 38 30L18 30C16.8954 30 16 29.1046 16 28C16 26.8954 16.8954 26 18 26L38 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingPlusSign);
export default __webpack_public_path__ + "static/media/MessagingPlusSign.738313a4043dfb893aed4febe39bacfc.svg";
export { ForwardRef as ReactComponent };